import Vue from 'vue'
import Vuex from 'vuex'
import {
  getToken,
  getZh
} from '@/utils/auth'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    token: getToken(),
    zh: getZh()
  },
  getters: {
    token: state => state.token,
    ZH: state => state.zh
  },
  mutations: {
    setToken(state, val) {
      state.token = val
    },
    clearToken(state) {
      state.token = ''
    },
    setZH(state, val) {
      state.zh = val
    },
    clearZH(state) {
      state.zh = ''
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js